import { render, staticRenderFns } from "./NbSchedule.vue?vue&type=template&id=38e375f2"
import script from "./NbSchedule.vue?vue&type=script&lang=js"
export * from "./NbSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports